module.exports = __webpack_public_path__ + "static/media/withoutstep5.88196d3b.png";